import { Button, Col, Dropdown, Menu, Popconfirm, Row, Space } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Bidder, bidderStatusKorean } from '../../modules/bidders';
import { priceToString } from '../../util/utils';
import { styledTable } from '../styled/mixin';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface BidderListComponentProps {
  bidders: Bidder[];
  isBriefing: boolean;
  addBidders: (type: string) => void;
  moveToBidderDetailPage: (bidderId: number) => void;
  onDelete: (bidderId: string) => void;
  sendBidInvitation: (selectedValues: number[]) => void;
  checkBriefingAttendants: (type: boolean, selectedValues: number[]) => void;
  bulkDeleteBidders: (selectedValues: number[]) => void;
}
function BidderListComponent({
  bidders,
  isBriefing,
  addBidders,
  moveToBidderDetailPage,
  onDelete,
  sendBidInvitation,
  checkBriefingAttendants,
  bulkDeleteBidders,
}: BidderListComponentProps) {
  useEffect(() => {
    setSelectedValues([]);
  }, []);

  const [selectedValues, setSelectedValues] = useState<any>([]);

  const columns: ColumnsType<Bidder> = [
    {
      title: '회사명',
      dataIndex: ['vendor', 'application', 'general'],
      render: (value: any, record: Bidder) => (
        <span
          className="clickable-table-item"
          onClick={() => moveToBidderDetailPage(record.id)}
        >
          {value.companyName}
        </span>
      ),
    },
    // {
    //   title: '담당자명',
    //   dataIndex: 'userName',
    //   render: (text: any, record: Bidder) =>
    //     record.bidEnterprise === null
    //       ? record.tempBidder.userName
    //       : record.users[0].name,
    // },
    {
      title: '상태',
      dataIndex: 'status',
      render: (text: any, record: Bidder) => bidderStatusKorean[record.status],
    },
    {
      title: '제출가',
      dataIndex: 'recentAmount',
      defaultSortOrder: 'descend',
      sorter: (a: Bidder, b: Bidder) => a?.recentAmount! - b?.recentAmount!,
      render: (text: any, record: Bidder) => (
        <span>
          {record.recentAmount ? priceToString(record.recentAmount) : null}
        </span>
      ),
    },
  ];

  if (isBriefing) {
    columns.splice(3, 0, {
      title: '현설참석여부',
      dataIndex: 'isBriefingAttend',
      render: (text: any, record: Bidder) =>
        record.isBriefingAttend ? '예' : '아니오',
    });
  }

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedValues([...selectedRowKeys]);
    },
    selectedRowKeys: selectedValues,
  };

  const menu = (
    <Menu>
      <Menu.Item key="0" onClick={() => addBidders('0')}>
        검색
      </Menu.Item>
      <Menu.Item key="1" onClick={() => addBidders('1')}>
        불러오기
      </Menu.Item>
      {/* <Menu.Item key="2" onClick={() => addBidders('2')}>
        업로드
      </Menu.Item> */}
    </Menu>
  );

  const menu2 = (
    <Menu>
      <Menu.Item
        key="0"
        onClick={() => checkBriefingAttendants(true, selectedValues)}
      >
        참석
      </Menu.Item>
      <Menu.Item
        key="1"
        onClick={() => checkBriefingAttendants(false, selectedValues)}
      >
        미참석
      </Menu.Item>
    </Menu>
  );

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Col>
          <h3>참가업체 리스트</h3>
        </Col>
        <Col>
          <Space size="small">
            {/* <Button
              onClick={() => checkBriefingAttendants(selectedValues)}
              size="small"
              disabled={!(selectedValues.length > 0)}
            >
              현설참석자 체크
            </Button> */}
            {isBriefing && (
              <Dropdown
                overlay={menu2}
                placement="bottomLeft"
                arrow
                disabled={!(selectedValues.length > 0)}
              >
                <Button size="small">현설관리</Button>
              </Dropdown>
            )}
            <Dropdown overlay={menu} placement="bottomLeft" arrow>
              <Button size="small">업체추가</Button>
            </Dropdown>
            <Button
              onClick={() => sendBidInvitation(selectedValues)}
              size="small"
              disabled={!(selectedValues.length > 0)}
            >
              견적요청
            </Button>
            <Popconfirm
              title="정말 삭제하시겠습니까?"
              onConfirm={() => bulkDeleteBidders(selectedValues)}
            >
              <Button
                size="small"
                disabled={!(selectedValues.length > 0)}
                danger
              >
                삭제
              </Button>
            </Popconfirm>
          </Space>
        </Col>
      </Row>

      {bidders && (
        <Table<Bidder>
          rowKey="id"
          columns={columns}
          dataSource={bidders}
          rowSelection={{ ...rowSelection, checkStrictly: false }}
          showSorterTooltip={false}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
            position: ['bottomCenter'],
          }}
        />
      )}
    </StyledDiv>
  );
}
export default BidderListComponent;
